import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/icon/add-notification.svg';

export default class extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon add-notification', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
